export interface HeaderConfig {
  displayHeader?: boolean;
  /**
   * @description This will enable intersection observable logic
   *
   * (Set to `false` for tables that are in dialog content)
   */
  enableStickyDirective?: boolean;
  /**
   * @description
   * The IntersectionObserver interface's read-only rootMargin property is a string with syntax similar to that of the CSS margin property.
   * Each side of the rectangle represented by rootMargin is added to the corresponding side in the root element's bounding box
   * before the intersection test is performed. This lets you, for example, adjust the bounds outward so that the target element
   * is considered 100% visible even if a certain number of pixels worth of width or height is clipped away,
   * or treat the target as partially hidden if an edge is too close to the edge of the root's bounding box.
   *
   * Read {@link https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/rootMargin more}
   */
  rootMargin?: string;
}
